import { SERVER_BASE_URL } from '@lib/constants';
import Image from 'next/image';
import React, { ReactElement } from 'react';

interface Props {
  imgUrl: string;
  alt: string;
}

export default function PartnerItem({ imgUrl, alt = '' }: Props): ReactElement {
  console.log(imgUrl)
  return (
    <span className="w-full min-h-[140px] flex justify-center items-center overflow-visible">
      <Image
        src={SERVER_BASE_URL + imgUrl || '#!'}
        className="object-contain"
        alt={alt || 'Partner Logo'}
        loading="lazy"
        width={220}
        height={100}
      />
    </span>
  );
}
